export class EstablishmentLeadContractResponseTransformers {
  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key.startsWith('contract.')) {
          key = key.slice(9);
        }

        return {
          [key]: value.join(', ')
        }
      });
    };
  }
}